export default __webpack_public_path__ + "static/media/HaloHeader.f80bf8dc.png";